<template>
  <v-tooltip bottom color="primary">
    <template slot="activator" slot-scope="{ on }">
      <v-btn
        v-on="on"
        :color="icon != '' ? '' : color"
        :class="myclass"
        :id="id"
        :ref="reff"
        v-tap="(e) => BtnClick()"
        :disabled="disabled"
        :fab="fab"
        :small="small"
        :icon="icon != ''"
        :large="large"
        :left="left"
        :right="right"
        :up="up"
        :down="down"
      >
        <v-icon :large="large" :color="color" v-if="icon != ''">{{ icon }}</v-icon>
        <div v-else>{{ lable }}</div>
      </v-btn>
    </template>
    <div v-if="!notooltip">
      <span v-if="tooltiplable == ''">{{ lable }}</span>
      <span v-if="!tooltiplable == ''">{{ tooltiplable }}</span>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    lable: {
      type: String,
      default: ""
    },
    tooltiplable: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "primary textColor--text"
    },
    myclass: {
      type: String,
      default: "ma-1"
    },
    id: {
      type: String,
      default: ""
    },
    reff: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    large: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    up: {
      type: Boolean,
      default: false
    },
    down: {
      type: Boolean,
      default: false
    },
    notooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    BtnClick() {
      this.$emit("click");
    }
  }
};

//@ sourceURL=mybun.js
</script>

<style></style>
